import { BrowserRouter, Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "@/components/auth/protected-route";
import { RedirectIfAuthed } from "@/components/auth/redirect-if-authed";
import { RequireAdmin } from "@/components/auth/require-admin";
import { AppShell } from "@/components/layout/app-shell";
import { ThemeProvider } from "@/components/theme-provider";
import { AuthProvider } from "@/lib/auth";
import {
  AccountTransactionsPage,
  AccountsPage,
  CreditCardsPage,
  DashboardPage,
  InvestmentsPage,
  InvitationAcceptPage,
  LoginPage,
  LoginTwoFactorPage,
  PasswordResetConfirmPage,
  PasswordResetRequestPage,
  SettingsPage,
  SettingsUsersPage,
} from "@/pages";
import { NotFoundPage } from "@/pages/not-found";

export function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="finance-theme">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<RedirectIfAuthed />}>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/login/2fa" element={<LoginTwoFactorPage />} />
            </Route>

            <Route
              path="/invitations/:token"
              element={<InvitationAcceptPage />}
            />

            <Route
              path="/password-reset/request"
              element={<PasswordResetRequestPage />}
            />
            <Route
              path="/password-reset/:token"
              element={<PasswordResetConfirmPage />}
            />

            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route index element={<DashboardPage />} />
                <Route path="/accounts" element={<AccountsPage />} />
                <Route
                  path="/accounts/:accountId/transactions"
                  element={<AccountTransactionsPage />}
                />
                <Route path="/credit-cards" element={<CreditCardsPage />} />
                <Route
                  path="/credit-cards/:accountId/transactions"
                  element={<AccountTransactionsPage />}
                />
                <Route path="/investments" element={<InvestmentsPage />} />
                <Route element={<RequireAdmin />}>
                  <Route path="/settings" element={<SettingsPage />} />
                  {/* Single mount handles both /settings/users and
                      /settings/users/invitations so switching the in-page
                      tabs doesn't re-mount the panel and drop search /
                      filter state. */}
                  <Route
                    path="/settings/users/*"
                    element={<SettingsUsersPage />}
                  />
                </Route>
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
